import classNames from 'classnames'
import { FieldStatus } from '../types'
import styles from './FieldHeader.module.scss'
import type { FieldHeaderProps } from './types'

const FieldHeader = ({
  status = FieldStatus.neutral,
  label,
  secondaryLabel,
  //withInfo = false,
  //onInfoClick,
  className,
  id,
}: FieldHeaderProps) => {
  return (
    <div className={classNames(styles['pintxo-field-header'], className)} data-status={status}>
      <div className={styles['pintxo-field-header__left']}>
        {label && (
          <span id={id} className={styles['pintxo-field-header__label']}>
            {label}
          </span>
        )}
        {secondaryLabel && (
          <span className={styles['pintxo-field-header__secondary-label']}>{secondaryLabel}</span>
        )}
        {/* {withInfo && (
          <UdsIcon
            name="infoCircle"
            size={IconSize.s}
            className="pintxo-field-header__info-icon"
            outline
            onClick={onInfoClick}
          />
        )} */}
      </div>
      <div className={styles['pintxo-field-header__right']}>
        {/*}<!-- Right section here --> */}
      </div>
    </div>
  )
}
export default FieldHeader
